module.exports = __webpack_public_path__ + "images/technologies-bg-mobile.png";